import { ArrowRight, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { capabilityMenu } from './navigationData';

export default function MegaMenuDropdown({ activeCapability, onCapabilityChange, onClose, onMouseEnter, onMouseLeave }) {
  const selected = capabilityMenu.find((item) => item.title === activeCapability) || capabilityMenu[0];
  return (
    <section
      id="capabilities-mega-menu"
      role="dialog"
      aria-label="Capabilities"
      className="fixed left-0 right-0 top-[76px] z-40 border-b border-hairline bg-arch-white xl:top-[84px]"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onKeyDown={(event) => { if (event.key === 'Escape') onClose(); }}
      data-testid="capabilities-mega-menu"
    >
      <div className="pr-container-wide py-8 xl:py-10">
        <div className="pr-grid">
          <div className="col-span-4 border-t border-hairline md:col-span-5 xl:col-span-7">
            <div className="flex items-center justify-between py-3"><p className="pr-eyebrow">Capabilities</p><button type="button" onClick={onClose} className="inline-flex min-h-[36px] items-center gap-2 text-[10px] font-medium uppercase tracking-[0.08em] text-warm-grey hover:text-soft-black" data-testid="capabilities-mega-menu-close">Close <X size={15} aria-hidden="true" /></button></div>
            {capabilityMenu.map((item) => (
              <Link
                to={item.href}
                key={item.number}
                onFocus={() => onCapabilityChange(item.title)}
                onMouseEnter={() => onCapabilityChange(item.title)}
                onClick={onClose}
                className="group grid grid-cols-[44px_1fr_auto] gap-3 border-t border-hairline py-3.5 no-underline transition-colors duration-150 hover:text-bronze"
                data-testid={`mega-capability-${item.number}`}
              >
                <span className="pr-eyebrow pt-1">{item.number}</span><span><span className="block text-base font-medium leading-tight">{item.title}</span><span className="mt-1 hidden max-w-sm text-sm leading-snug text-warm-grey lg:block">{item.description}</span></span><ArrowRight size={17} className="mt-1 transition-transform duration-150 group-hover:translate-x-1" aria-hidden="true" />
              </Link>
            ))}
          </div>
          <div className="relative col-span-4 hidden min-h-[470px] overflow-hidden bg-warm-ivory md:col-span-3 xl:col-span-5 xl:block" data-testid="mega-menu-context-image">
            <img src={selected.image} alt="Prastara fabrication and interior detail" className="absolute inset-0 h-full w-full object-cover transition-opacity duration-300" />
            <div className="absolute inset-x-0 bottom-0 bg-soft-black p-6 text-arch-white"><p className="pr-eyebrow text-stone">{selected.number} / Capability</p><p className="mt-2 text-2xl font-medium">{selected.title}</p><p className="mt-2 max-w-sm text-sm leading-relaxed text-arch-white/65">{selected.description}</p></div>
          </div>
        </div>
      </div>
    </section>
  );
}